/**
 * @file: 计算卧柜溢出，闲置区域宽度
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree';
import * as UIToolkit from '../../UIToolkit';
import FrontCubeData from '../../frontCubeData';
import Utils from '../../utils/util';
import { getColWidth } from './getColWidth';

// 闲置区域宽度
function getEmptyWidth(freezer: CubeId): PhysicsMeasurement {
    let freezerCubes: CubeId[] = CubeTree.findCubesInFreezer(freezer, []);
    let cols: CubeId[][] = UIToolkit.makeSkuCubesColGroupList(freezerCubes);
    let freezerWidth: PhysicsMeasurement = FrontCubeData.getNumberValue(freezer, 'width');

    if (cols.length === 0) {
        return freezerWidth;
    }

    let theLastColCubes: CubeId[] = cols[cols.length - 1];
    let colWidth: PhysicsMeasurement = getColWidth(theLastColCubes);
    let left: PhysicsMeasurement = FrontCubeData.getNumberValue(theLastColCubes[0], 'posX');
    let rightLine: PhysicsMeasurement = Utils.math(left, colWidth, '+');

    return Utils.math(freezerWidth, rightLine, '-');
}

// 溢出宽度
function getOverflowWidth(freezer: CubeId): PhysicsMeasurement {
    let overflowWidth: PhysicsMeasurement = 0;

    if (freezer) {
        overflowWidth = getEmptyWidth(freezer);
    }
    else {
        return 0;
    }

    overflowWidth = -overflowWidth;

    return overflowWidth;
}

export {
    getEmptyWidth,
    getOverflowWidth
};
